'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
function findKey(obj, predicate) {
    var keys = Object.keys(obj);
    return keys.find(function(key) {
        return predicate(obj[key], key, obj);
    });
}
exports.findKey = findKey;
